import {
  isSuperAdminRole,
  permissionsForMatrix,
  type Permission,
  type PermissionAction,
  type PermissionResource,
} from '@erp/shared';
import { useSession } from '@/features/auth/api/use-session';

export interface PermissionGate {
  can: (permission: Permission) => boolean;
  canAccess: (resource: PermissionResource, action: PermissionAction) => boolean;
  isSuperAdmin: boolean;
  permissions: readonly string[];
}

export function usePermissions(): PermissionGate {
  const { data } = useSession();
  const permissions = data?.permissions ?? [];
  // Die Eigentümerrolle umgeht Einzelprüfungen, analog zum Guard der API.
  const isSuperAdmin = data !== null && data !== undefined && isSuperAdminRole(data.roleKey);

  return {
    permissions,
    isSuperAdmin,
    can: (permission) => isSuperAdmin || permissions.includes(permission),
    canAccess: (resource, action) => {
      if (isSuperAdmin) {
        return true;
      }
      const required = permissionsForMatrix([{ resource, action }]);
      return required.length > 0 && required.every((entry) => permissions.includes(entry));
    },
  };
}
